import _ from 'lodash';
import React from 'react';
import { withRouter } from 'react-router';
import "./CustomerRequestsInvoiceDetailContainer.less"
import { useParams } from 'react-router';
import RequestInvoiceDetail from '../../../components/SellerCustomer/RequestInvoiceDetail/RequestInvoiceDetail';
import { NavigationUrls } from '../../../constants/NavigationUrls'

function CustomerRequestsInvoiceDetailContainer(props) {
  
  const params = useParams();

  const redirectToHomePage = () => {
    props.history.push(NavigationUrls.CUSTOMER_REQUESTS_LIST);  
  }

return (
    <div className="request-invoice-detail-container">
        {params && params.scRequestID ? 
          <>
          {
            <div className={"heading-container"}>
                <div onClick={() => {redirectToHomePage()}} className={"home-icon"}>
                <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41">
                  <defs>
                    <clipPath id="clip-path">
                      <rect id="Rectangle_9028" data-name="Rectangle 9028" width="21.679" height="20.981" transform="translate(0 0)" fill="#5d79e7"/>
                    </clipPath>
                  </defs>
                  <g id="Group_16385" data-name="Group 16385" transform="translate(-15 -102)">
                    <g id="Group_16407" data-name="Group 16407" transform="translate(-100 -49)">
                      <g id="Group_16370" data-name="Group 16370" transform="translate(100 49)">
                        <rect id="Rectangle_9022" data-name="Rectangle 9022" width="41" height="41" rx="13" transform="translate(15 102)" fill="#ebf2fe"/>
                      </g>
                    </g>
                    <g id="Group_16408" data-name="Group 16408" transform="translate(25 112)">
                      <g id="Group_16404" data-name="Group 16404" transform="translate(0 0)" clip-path="url(#clip-path)">
                        <path id="Path_42133" data-name="Path 42133" d="M10.938,4.323c-.131.087-.248.161-.361.24C8.26,6.18,5.948,7.8,3.623,9.409a.853.853,0,0,0-.414.8c.013,3.42.007,6.841.009,10.261,0,.166.014.333.022.505H8.818V15.813h4v5.169H18.6a1.288,1.288,0,0,0,.026-.169c0-3.608.006-7.216-.009-10.824a.7.7,0,0,0-.272-.474c-.741-.546-1.5-1.065-2.257-1.593l-5.149-3.6M10.91,2.612c.689.489,1.363.965,2.036,1.444Q16.379,6.5,19.812,8.938A1.062,1.062,0,0,0,21.154,9a1.188,1.188,0,0,0,.452-1.368,1.934,1.934,0,0,0-.635-.769Q16.487,3.635,11.979.443a1.321,1.321,0,0,0-1.973,0Q5.3,3.8.6,7.167A1.221,1.221,0,0,0,.23,8.922c.4.558,1,.606,1.681.123Q3.933,7.606,5.948,6.16L10.91,2.612" transform="translate(0 0)" fill="#5d79e7"/>
                        <path id="Path_42134" data-name="Path 42134" d="M24.844,23.062l5.149,3.6c.755.528,1.516,1.047,2.257,1.593a.7.7,0,0,1,.272.473c.015,3.608.01,7.216.009,10.824a1.283,1.283,0,0,1-.026.169H26.725V34.552h-4v5.165H17.146c-.008-.172-.022-.339-.022-.505,0-3.42,0-6.841-.009-10.261a.853.853,0,0,1,.414-.8c2.325-1.6,4.637-3.229,6.954-4.846.113-.079.231-.153.361-.24" transform="translate(-13.907 -18.739)" fill="#5d79e7"/>
                        <path id="Path_42135" data-name="Path 42135" d="M10.91,2.612,5.948,6.16Q3.93,7.6,1.911,9.044C1.232,9.528.631,9.48.23,8.922A1.221,1.221,0,0,1,.6,7.167Q5.3,3.8,10.006.442a1.321,1.321,0,0,1,1.973,0q4.5,3.2,8.991,6.418a1.934,1.934,0,0,1,.635.769A1.188,1.188,0,0,1,21.154,9a1.062,1.062,0,0,1-1.341-.06Q16.376,6.5,12.946,4.056C12.274,3.577,11.6,3.1,10.91,2.612" transform="translate(0 0)" fill="#5d79e7"/>
                      </g>
                    </g>
                  </g>
                </svg>
                </div>
                <div className={"heading"}>
                  Invoice
                </div>
            </div>
          }
          
          <RequestInvoiceDetail  scRequestID={params.scRequestID} />
          </>
          : <h1>
              No invoice found
            </h1>
        }  
    </div>
  );
}


export default withRouter(CustomerRequestsInvoiceDetailContainer)